module.exports = __webpack_public_path__ + "static/img/s4.20ae3d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/an/s4.png
// module id = 5079
// module chunks = 1